<template>
  <div class="d-flex flex-column flex-grow-1">
    <div class="none-height flex-grow-1 d-flex flex-column position-relative section-container"
    :class="{'dark':skinType}"
    style="border-radius:4px;">

      <div class="d-flex align-items-center section-header"
      style="padding:1rem 1rem 0.5rem;">
        <div
          style="
            width: 0.3rem;
            height: 1.7rem;
            background-color: #2e9bf3;
          "
        ></div>
        <div style="font-size: 1.2rem; margin-left: 10px">基本信息</div>
      </div>
      <el-row class="d-flex flex-grow-1 position-relative" style="padding:12px 42px;">
         <div class="d-flex align-items-center position-absolute cursor-pointer"
         style="right:4rem;top:2rem;font-size:1.2rem;color: #2e9bf3"
         v-on:click="editPersonalInfo"><i class="el-icon-edit"></i>编辑</div>
        <el-col :span="18" class="d-flex flex-column justify-content-around">
          <el-row
            class="base-info-item d-flex"
            v-for="(propList, index) of basePropList"
            :key="'prop-' + index"
          >
            <el-col
              class="d-flex"
              :span="8"
              v-for="(prop, order) of propList"
              :key="prop + order"
            >
              {{ baseInfoProps.get(prop) }}: {{ info[prop] }}
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6" class="d-flex flex-column justify-content-center">
          <el-upload
            class="avatar-uploader"
            :action="`${baseUrl}${settingUrl}?UIDstr=${accountId}`"
            :show-file-list="false"
            name="F_HeadIcon"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <div class="d-flex flex-column">
              <el-image
				v-if="info.F_HeadIcon"
                style="width: 100px; height: 100px;border-radius:50%;"
                :src="`${baseUrl}${form.F_HeadIcon}`"
                fit="cover"
				lazy
              ></el-image>
              <el-button  slot="trigger" type="primary" style="margin-top:1rem;"
               size="mini" class="">修改头像</el-button>
            </div>
          </el-upload>
        </el-col>
      </el-row>
    </div>
    <div class="none-height flex-grow-1 d-flex flex-column section-container"
    :class="{'dark':skinType}"
    style="margin-top:1rem;border-radius:4px;">
      <div class="d-flex align-items-center section-header"
          style="padding:1rem 1rem 0.5rem;">
        <div
          style="
            width: 0.3rem;
            height: 1.7rem;
            background-color: #2e9bf3;
          "
        ></div>
        <div style="font-size:1.2rem;margin-left: 10px">账户安全</div>
      </div>
      <div class="d-flex flex-column flex-grow-1 justify-content-around" style="padding:12px 42px;">
        <div class="d-flex">
          <div>登录账号: {{info.F_Account}}</div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center"><i class="el-icon-success"></i>
          <div>登录密码:用于登录，已验证通过;为了账号安全，建议您定期更改账号密码</div></div>
          <el-button type="primary" size="mini" v-on:click="showResetPasswords">修改</el-button>
        </div>
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <i :class="[info.F_MobilePhone?'el-icon-success':'el-icon-error']">
            </i>
            <div>手机号:手机号用于接收短信通知;{{info.F_MobilePhone?
              `账户已绑定手机号${hintPhone},`
              :'未绑定手机号，请尽快绑定手机号'}}</div>
          </div>
          <el-button type="primary" size="mini" v-on:click="showChangePhone">修改</el-button>
        </div>
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <i :class="[info.F_Email?'el-icon-success':'el-icon-error']">
            </i>
            <div>邮箱:用于验证身份，{{info.F_Email?
              `账户已绑定邮箱`
              :'未绑定;您可绑定邮箱'}}</div></div>
          <el-button type="primary" size="mini" disabled v-on:click="showChangeMail">修改</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%"
    :class="{'dark':skinType}">
      <reset-passwords
        @changeResult="changeResultListener"
        v-if="dialogType == 0"
      ></reset-passwords>
      <change-phone @changeResult="changeResultListener"
      v-else-if="dialogType==1"></change-phone>
      <change-person-info  @changeResult="changeResultListener"
      v-else-if="dialogType==2"></change-person-info>
      <change-mail v-else @changeResult="changeResultListener"></change-mail>
    </el-dialog>
  </div>
</template>
<script>
import ResetPasswords from '@/components/personal-center/reset-passwords.vue';
import ChangePhone from '@/components/personal-center/change-phone.vue';
import ChangePersonInfo from '@/components/personal-center/change-personInfo.vue';
import ChangeMail from '@/components/personal-center/change-mail.vue';
import {
  getPersonalInfo,
  modifyPersonalInfo,
  USER_SETTING,
} from '@/api/personal-center/setting';
import { convertDataToFormData } from '@/utils/utils';
import { BASE_URL } from '@/utils/request/request';

export default {
  components: {
    ResetPasswords,
    ChangePhone,
    ChangePersonInfo,
    ChangeMail,
  },
  data() {
    return {
      baseInfoProps: new Map([
        ['F_RealName', '姓名'],
        ['F_NickName', '昵称'],
        ['GenderName', '性别'],
        // ['F_Account', '账号'],
        ['RoleName', '角色'],
        ['DeparmentName', '部门'],
        ['OrganizationName', '组织名称'],
        ['F_Description', '账号说明'],
      ]),
      nickEditable: 'disabled',
      baseUrl: BASE_URL,
      settingUrl: USER_SETTING,
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: '',
      info: {},
      form: {
        avatarUrl: '',
        name: '',
        gender: 1,
        contact: '13567894514',
      },
    };
  },
  created() {
    this.requestPersonalInfo();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    accountId() {
      return this.$store.getters.accountId;
    },
    uploadData() {
      return {
        UIDstr: this.accountId,
      };
    },
    basePropList() {
      const list = [...this.baseInfoProps.keys()];
      const arr = [];
      for (let i = 0; i < list.length; i += 3) {
        arr.push(list.slice(i, i + 3));
      }
      return arr;
    },
    hintPhone() {
      const arr = this.info.F_MobilePhone.split('');
      arr.splice(2, arr.length - 3, '*******');
      return arr.join('');
    },
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        console.log('newVal', newVal);
      },
    },
  },
  methods: {
    changeResultListener() {
      this.dialogVisible = false;
      this.requestPersonalInfo();
    },
    requestPersonalInfo() {
      getPersonalInfo({
        UIDstr: this.accountId,
      }).then((res) => {
        this.info = res.list[0];
        this.form = { ...this.info };
      });
    },
    handleAvatarSuccess(res) {
      this.info = res.Data_Obj;
      this.form.F_HeadIcon = res.Data_Obj.F_HeadIcon;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    onSubmit() {
      const formData = convertDataToFormData(this.form);
      formData.delete('F_HeadIcon');
      modifyPersonalInfo(formData, {
        UIDstr: this.accountId,
      }).then((res) => {
        console.log(res);
      });
      console.log('submit!');
    },
    showResetPasswords() {
      this.dialogType = 0;
      this.dialogTitle = '重置密码';
      this.dialogVisible = true;
    },
    showChangePhone() {
      this.dialogType = 1;
      this.dialogTitle = '设置手机号';
      this.dialogVisible = true;
    },
    showChangeMail() {
      this.dialogType = 3;
      this.dialogTitle = '设置邮箱';
      this.dialogVisible = true;
    },
    editPersonalInfo() {
      this.dialogType = 2;
      this.dialogTitle = '个人信息修改';
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped>
.personal-info-setting {
  padding: 10% 25%;
}
.avatar-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: #cdcdcd dashed 0.1rem;
  border-radius: 50%;
}
</style>
